import React, { useState, useEffect } from "react";
import styles from "./team.module.css";
import Avatar from "@mui/material/Avatar";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import Alert from "@material-ui/lab/Alert";
import { TextField } from "formik-material-ui";
import TextFielded from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import { ReactComponent as AddDevice } from "../../utils/assets/The_Num_of_Device.svg";
import { ReactComponent as Arrow } from "../../utils/assets/q.svg";
import RenderCheckBox from "components/dashboard/render-checkbox-team";
import FormControlComponent from "../../components/dashboard/form-control";
import ButtonComponent from "./buttonComponent";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { ReactComponent as CrossMark } from "../../utils/assets/CrossMark.svg";
import { Autocomplete } from "formik-mui";
import Snackbar from "@mui/material/Snackbar";
import SearchBar from "./searchBar";
import { Typography } from "@material-ui/core";
import { DEFAULT_ALERT } from "utils/strings";

export default function Team() {
  const axios = useAxiosPrivate();
  const coachName = useSelector((state) => state.auth.name);
  const [members, setMembers] = useState([]);
  const [membersChecked, setMembersChecked] = useState([]);
  const [edit, setEdit] = useState(false);
  const [userValue, setUserValue] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [groupCategory, setGroupCategory] = useState([]);
  const [group, setGroup] = useState("");
  const [checkedSelected, setCheckedSelected] = useState([]);
  const formName = "Select Team";
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteTeam, setDeleteTeam] = useState(false);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [initialValues, setInitialValues] = useState({
    coachName: coachName,
    teamName: "",
    name: "",
    category_id: "",
    players: [],
  });
  const [options, setOptions] = useState([]);
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    loadDataGroupData();
    loadCategory();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (groupData) {
      if (groupData.find((item) => item?.id === group)?.name === undefined) {
        setGroup("");
      }
    }
    // eslint-disable-next-line
  }, [groupData]);

  useEffect(() => {
    if (coachName) {
      setInitialValues({
        ...initialValues,
        coachName: coachName,
        players: [...userValue],
      });
    }
    // eslint-disable-next-line
  }, [coachName]);

  useEffect(() => {
    if (edit) {
      if (group !== "default") {
        setInitialValues({
          coachName: groupData.find((item) => item?.id === group)?.coach_name,
          teamName: groupData.find((item) => item.id === group)?.name,
          name: groupData.find((item) => item?.id === group)?.category,
          category_id: groupData.find((item) => item?.id === group)
            ?.category_id,
          players: [...userValue],
        });
        loadAllpayersData();
        setUserValue([...membersChecked]);
      } else {
        setInitialValues({
          ...initialValues,
          teamName: "",
          name: "",
          category_id: "",
          players: [],
        });
        setUserValue([]);
      }
    } else {
      setUserValue([]);
      loadData();
    }
    // eslint-disable-next-line
  }, [edit]);

  useEffect(() => {
    setEdit(false);
    setUserValue([]);
    if (group === "default") {
      loadAllpayersData();
      setInitialValues({
        ...initialValues,
        teamName: "",
        name: "",
        category_id: "",
        players: [],
      });
    } else {
      if (group !== "") {
        loadData();
        setInitialValues({
          coachName: groupData.find((item) => item?.id === group)?.admin_name,
          teamName: groupData.find((item) => item?.id === group)?.name,
          name: groupData.find((item) => item?.id === group)?.category,
          category_id: groupData.find((item) => item?.id === group)
            ?.category_id,
          players: [...userValue],
        });
      }
    }
    // eslint-disable-next-line
  }, [group]);

  useEffect(() => {
    if (userValue) {
      setInitialValues({
        ...initialValues,
        players: [...userValue],
      });
    }
    // eslint-disable-next-line
  }, [userValue]);

  useEffect(() => {
    if (checkedSelected?.length > 0) {
      if (group !== "default") {
        let obj = { group_id: group, user_id: checkedSelected[0] };
        let checktheCurrentPlayer = membersChecked.includes(checkedSelected[0]);
        if (checktheCurrentPlayer) {
          if (initialValues?.players?.length === 1) {
            setUserValue([...checkedSelected]);
            setAlert({
              showAlert: true,
              severity: "error",
              message: "The team should have a minimum of one patient",
            });
            setOpen(true);
            setTimeout(() => {
              setAlert({
                showAlert: false,
                severity: "error",
                message: "The team should have a minimum of one patient",
              });
            }, 5000);
          } else {
            removePlayer(obj);
          }
        } else {
          addPlayer(obj);
        }
      }
    }
    // eslint-disable-next-line
  }, [checkedSelected]);

  useEffect(() => {
    if (pageNumber) {
      loadData();
      if (group !== "") {
        loadAllpayersData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  useEffect(() => {
    if (searchValue?.length === 0) {
      loadAllpayersData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  const submit = async (e, { resetForm }) => {
    try {
      const result = await axios.post("/group/create", {
        name: e.teamName,
        category_id: initialValues.category_id
          ? initialValues.category_id
          : null,
        category: initialValues.name,
        players: e.players,
      });
      await loadDataGroupData();
      resetForm();
      setInitialValues({
        coachName: coachName,
        teamName: "",
        name: "",
        category_id: "",
        players: [],
      });
      setGroup(result?.data?.data?.group_id);
      setAlert({
        showAlert: true,
        severity: "Success",
        message: "Team created Successfully!",
      });
      setOpen(true);
      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: "Success",
          message: "Team created Successfully!",
        });
      }, 5000);
    } catch (error) {
      if (error.response && error.response?.data) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: error.response?.data?.message,
        });
        setOpen(true);
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Something error!",
        });
        setOpen(true);
      }
    }
  };

  let teamSchema = Yup.object().shape({
    teamName: Yup.string().required("Please enter team name").min(2).nullable(),
    name: Yup.string()
      .required("Category name is required.")
      .nullable()
      .test("Unique", "Category already exists", (values) => {
        if (initialValues?.category_id) {
          return true;
        } else {
          return groupCategory.find(
            (item) => item?.name?.toUpperCase() === values?.toUpperCase()
          )
            ? false
            : true;
        }
      }),
  });

  const loadData = async () => {
    try {
      if (group !== "default" && group !== "") {
        const { data } = await axios.get(
          `/team/dashboard?page=${pageNumber}&page_size=10&group_id=${group}`
        );
        setCount(data.total_pages);
        setMembers(data.data);
        let checkMembers = [];
        for (let item of data.data) {
          checkMembers.push(item.user_id);
        }
        setMembersChecked([...checkMembers]);
      } else {
        setMembers([]);
      }
      setAlert(DEFAULT_ALERT);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message:
          "You're not in a Team yet. Please ask your team admin to invite you in.",
      });
      setOpen(true);
    }
  };

  const loadAllpayersData = async () => {
    try {
      const { data } = await axios.get(
        `/team/players?page=${pageNumber}&page_size=10&order=asc&order_by=first_name&search=${searchValue}`
      );
      if (group !== "") {
        setCount(data.total_pages);
        setMembers(data.data);
        if (group === "default") {
          setEdit(true);
        }
      }
      setAlert(DEFAULT_ALERT);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message:
          "You're not in a Team yet. Please ask your team admin to invite you in.",
      });
      setOpen(true);
    }
  };

  const loadDataGroupData = async () => {
    try {
      const profile = await axios.get("/user/profile");
      const defaultData = profile.data.data.groups;
      defaultData.sort(function (a, b) {
        if (a?.name.toLowerCase() < b?.name.toLowerCase()) {
          return -1;
        }
        if (a?.name.toLowerCase() > b?.name.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      defaultData.push({ id: "default", name: "Add Team +" });
      setGroupData(defaultData);
      setMembers([]);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Something was wrong!",
      });
      setOpen(true);
    }
  };

  const addPlayer = async (parms) => {
    try {
      await axios.post("/group/add_player", { ...parms });
      setMembersChecked([...membersChecked, parms.user_id]);
      setUserValue([...membersChecked, parms.user_id]);
      setAlert({
        showAlert: true,
        severity: "Success",
        message: "Patient added to the group",
      });
      setOpen(true);
      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: "Success",
          message: "Patient added to the group",
        });
      }, 5000);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: error.response?.data?.message,
      });
      setOpen(true);
    }
  };

  const removePlayer = async (parms) => {
    try {
      await axios.delete(`/group/${parms?.group_id}/player/${parms.user_id}`);
      let removeMemberCheckedArray = membersChecked.filter(
        (item) => item !== parms.user_id
      );
      setMembersChecked([...removeMemberCheckedArray]);
      setUserValue([...removeMemberCheckedArray]);
      setAlert({
        showAlert: true,
        severity: "Success",
        message: "Patient removed",
      });
      setOpen(true);
      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: "Success",
          message: "Patient removed",
        });
      }, 5000);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: error.response?.data?.message,
      });
    }
  };

  const loadCategory = async () => {
    try {
      const { data } = await axios.get("/group/categories");
      const allCategories = data.data;
      allCategories.sort(function (a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      setGroupCategory([...allCategories]);
      const option = data.data.map((op) => op.name);
      setOptions([...option]);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Something was wrong!",
      });
      setOpen(true);
    }
  };

  const handleChange = (event, value) => {
    setPageNumber(value);
  };

  const handleCategoryChange = (event, value) => {
    let obj = value;
    if (typeof value === "string") {
      obj = {
        id: null,
        name: value,
        team_id: null,
        updatedAt: null,
        createdAt: null,
      };
    }
    setInitialValues({
      ...initialValues,
      name: obj.name,
      category_id: groupCategory.find((item) => item.name === obj.name)?.id
        ? groupCategory.find((item) => item.name === obj.name)?.id
        : null,
    });
  };
  const handleTeamNameChange = (event, value) => {
    setInitialValues({
      ...initialValues,
      teamName: event.target.value,
    });
  };

  return (
    <div style={{ marginTop: "2rem" }}>
      <Formik
        initialValues={initialValues}
        onSubmit={submit}
        validationSchema={teamSchema}
        enableReinitialize
      >
        {({ dirty, isValid, values, errors, touched, setFieldValue }) => {
          return (
            <Form>
              <div className={styles.formHeadTop}>
                <Grid
                  container
                  style={{
                    width: "76%",
                    height: "3rem",
                  }}
                >
                  <Grid
                    item
                    md={6}
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <FormControlComponent
                      groupData={groupData}
                      setGroup={setGroup}
                      group={group}
                      formName={formName}
                    />
                  </Grid>
                  <ButtonComponent
                    dirty={dirty}
                    isValid={isValid}
                    edit={edit}
                    setEdit={setEdit}
                    group={group}
                    setAlert={setAlert}
                    loadDataGroupData={loadDataGroupData}
                    userValue={userValue}
                    initialValues={initialValues}
                    setOpenMessage={setOpen}
                    setDeleteTeam={setDeleteTeam}
                  />
                </Grid>
              </div>
              <div className={styles.tableHead}>
                <div className={styles.header1}>
                  <div className={styles.topbar1}>
                    <Typography
                      variant="h3"
                      style={{ fontSize: "14px", lineHeight: "1rem" }}
                    >
                      Team Name
                    </Typography>
                  </div>
                  <div className={styles.topbar2}>
                    <Typography
                      variant="h3"
                      style={{ fontSize: "14px", lineHeight: "1rem" }}
                    >
                      Physician
                    </Typography>
                  </div>
                  <div className={styles.topbar3}>
                    <Typography
                      variant="h3"
                      style={{ fontSize: "14px", lineHeight: "1rem" }}
                    >
                      Category
                    </Typography>
                  </div>
                </div>
              </div>
              <div className={styles.container}>
                {group === "" ? (
                  deleteTeam ? (
                    <div className={styles.tBody1}>
                      <div className={styles.topbarDefault}>
                        <Typography
                          variant="h2"
                          style={{ fontSize: "14px", lineHeight: "1rem" }}
                        >
                          Team Deleted! Click on “Select Team” to display
                          team/create a new team.
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    <div className={styles.tBody1}>
                      <div className={styles.topbarDefault}>
                        <Typography
                          variant="h2"
                          style={{ fontSize: "14px", lineHeight: "1rem" }}
                        >
                          {" "}
                          Click on “Select Team” to display team/create a new
                          team.
                        </Typography>
                      </div>
                    </div>
                  )
                ) : group === "default" || edit ? (
                  <div className={styles.tBody1}>
                    <Grid container className={styles.tBodyIn}>
                      <Grid
                        item
                        md={4}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Field
                          style={{
                            marginBottom: "1.8rem",
                            fontFamily: "Poppins",
                            width: "12rem",
                          }}
                          name="teamName"
                          label="Enter the team name"
                          component={TextField}
                          onKeyPress={(ev) => {
                            if (ev.key === "Enter") {
                              ev.preventDefault();
                              document.getElementById("categories").focus();
                            }
                          }}
                          variant="outlined"
                          fullWidth
                          margin="dense"
                          onChange={handleTeamNameChange}
                          error={
                            Boolean(errors.teamName) &&
                            Boolean(touched.teamName)
                          }
                          helperText={
                            Boolean(touched.teamName) && errors.teamName
                          }
                        ></Field>
                      </Grid>
                      <Grid
                        item
                        md={4}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Field
                          style={{
                            marginBottom: "1.8rem",
                            fontFamily: "Poppins",
                            width: "12rem",
                          }}
                          name="coachName"
                          label="Enter the physician name"
                          component={TextField}
                          variant="outlined"
                          fullWidth
                          margin="dense"
                          disabled
                        ></Field>
                      </Grid>
                      <Grid
                        item
                        md={4}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <FormControl
                          style={{
                            marginTop: "6px",
                            width: 200,
                          }}
                        >
                          <Field
                            size={"small"}
                            style={{
                              marginTop: "0rem",
                              fontFamily: "Poppins",
                              minWidth: "1rem",
                            }}
                            freeSolo
                            onChange={handleCategoryChange}
                            options={options}
                            component={Autocomplete}
                            name="name"
                            id="categories"
                            renderInput={(params) => (
                              <TextFielded
                                label="Choose category"
                                onChange={(e) => {
                                  e.preventDefault();
                                  setFieldValue("name", e.target.value);
                                  setInitialValues({
                                    ...initialValues,
                                    name: e.target.value,
                                    category_id: null,
                                  });
                                }}
                                {...params}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                                inputProps={{
                                  ...params.inputProps,
                                  maxLength: 15,
                                }}
                              />
                            )}
                            error={
                              Boolean(errors.name) && Boolean(touched.name)
                            }
                            helperText={Boolean(touched.name) && errors.name}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  <div className={styles.tBody1}>
                    <div className={styles.topbar1}>
                      <Typography
                        variant="h2"
                        style={{ fontSize: "14px", lineHeight: "1rem" }}
                      >
                        {initialValues?.teamName}
                      </Typography>
                    </div>
                    <div className={styles.topbar2}>
                      <Typography
                        variant="h2"
                        style={{ fontSize: "14px", lineHeight: "1rem" }}
                      >
                        {initialValues?.coachName}
                      </Typography>
                    </div>
                    <div className={styles.topbar3}>
                      <Typography
                        variant="h2"
                        style={{ fontSize: "14px", lineHeight: "1rem" }}
                      >
                        {initialValues?.name}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
              {edit && (
                <SearchBar
                  setSearchValue={setSearchValue}
                  searchValue={searchValue}
                  loadAllpayersData={loadAllpayersData}
                />
              )}
              <div className={styles.tableHead}>
                <div className={styles.header}>
                  <div
                    className={styles.headingCount}
                    style={{ cursor: "pointer" }} /* onClick={dataSort} */
                  >
                    <AddDevice />
                    <Typography
                      variant="h5"
                      style={{ fontSize: "14px", lineHeight: "1rem" }}
                    >
                      {members?.length}
                    </Typography>
                  </div>
                  <div className={styles.tittle1} style={{ cursor: "pointer" }}>
                    <Typography
                      variant="h5"
                      style={{
                        fontSize: "14px",
                        lineHeight: "1rem",
                        marginLeft: "0.7rem",
                      }}
                    >
                      UserName
                    </Typography>
                    <Arrow
                      style={{
                        width: "0.8rem",
                        height: "0.8rem",
                        marginLeft: "0.5rem",
                      }}
                    />
                  </div>
                  <div className={styles.tittle2}>
                    <Typography
                      variant="h5"
                      style={{ fontSize: "14px", lineHeight: "1rem" }}
                    >
                      Email
                    </Typography>
                  </div>
                  <div className={styles.tittle3}>
                    <Typography
                      variant="h5"
                      style={{ fontSize: "14px", lineHeight: "1rem" }}
                    >
                      Date Of Birth
                    </Typography>
                  </div>
                  <div className={styles.tittle4}>
                    <Typography
                      variant="h5"
                      style={{ fontSize: "14px", lineHeight: "1rem" }}
                    >
                      Gender
                    </Typography>
                  </div>
                </div>
              </div>
              {members.length > 0 ? (
                members.map((item, index) => (
                  <div
                    className={styles.container}
                    style={{ cursor: "pointer" }}
                    key={index}
                  >
                    <div className={styles.tBody}>
                      <div className={styles.tittle6}>
                        <div className={styles.item1}>
                          {edit ? (
                            <RenderCheckBox
                              members={userValue}
                              item={item}
                              setUserValue={setUserValue}
                              membersChecked={membersChecked}
                              setCheckedSelected={setCheckedSelected}
                            />
                          ) : null}
                        </div>
                        <div className={styles.item2}>
                          {" "}
                          <Avatar
                            alt={item?.first_name}
                            src={item.avatar_url}
                            sx={{ width: 30, height: 30 }}
                          />
                        </div>
                        <div className={styles.item3}>
                          {" "}
                          <Typography
                            variant="h4"
                            style={{
                              fontSize: "14px",
                              lineHeight: "1rem",
                              textDecoration: "underline",
                              textTransform: "capitalize",
                            }}
                          >
                            {item?.first_name}&nbsp; {item?.last_name}
                          </Typography>
                        </div>
                      </div>
                      <div className={styles.tittle7}>
                        <Typography
                          variant="h4"
                          style={{ fontSize: "14px", lineHeight: "1rem" }}
                        >
                          {" "}
                          {item?.email}
                        </Typography>
                      </div>
                      <div className={styles.tittle3}>
                        <Typography
                          variant="h4"
                          style={{ fontSize: "14px", lineHeight: "1rem" }}
                        >
                          {item.dob}
                        </Typography>
                      </div>
                      <div className={styles.tittle3}>
                        <Typography
                          variant="h4"
                          style={{
                            fontSize: "14px",
                            lineHeight: "1rem",
                            textTransform: "capitalize",
                          }}
                        >
                          {item?.gender ? item?.gender : "-"}
                        </Typography>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className={styles.container}>
                  <div className={styles.tBodyDefault}>
                    {group !== "" ? (
                      <CrossMark
                        style={{ cursor: "pointer" }}
                        onClick={() => loadAllpayersData()}
                      />
                    ) : null}
                  </div>
                </div>
              )}
              <div className={styles.Pagination}>
                <Stack spacing={2}>
                  <Pagination
                    count={count}
                    page={pageNumber}
                    variant="outlined"
                    shape="rounded"
                    onChange={handleChange}
                    style={{
                      transform: "scale(0.8)",
                    }}
                  />
                </Stack>
              </div>
            </Form>
          );
        }}
      </Formik>
      {alert.showAlert ? (
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
        >
          <Alert
            severity={alert.severity}
            onClose={() =>
              setAlert({
                ...alert,
                showAlert: false,
              })
            }
          >
            {alert.message}
          </Alert>
        </Snackbar>
      ) : (
        <p style={{ height: "1.3rem" }}></p>
      )}
    </div>
  );
}
